export default __webpack_public_path__ + "static/media/corner_white.e14d68ac.svg";